import Vue from 'vue';
import jwtDecode from 'jwt-decode';

import router from '@/router';
import { cloneDeep } from '@/helpers';
import AuthApi from '@/extensions/restricted-area/store/api/auth';
import MemberApi from '@/extensions/restricted-area/store/api/member';

import apolloProvider from '@/vue-apollo';

// init custom validation rules
import '@/extensions/restricted-area/helpers/validate';

// initial state

const token = AuthApi.getToken();
const jwt = token ? jwtDecode(token) : {};

const state = {
  // signin: ((AuthApi.getToken() !== null)),
  member: {},
  token,
  jwt
};

// getters
const getters = {
  member: state => state.member,
  isAuthenticated: state => !!state.token,
  token: state => state.token
};

// actions
const actions = {
  // register({ commit }, member) {
  //   return AuthApi.register(member).then(({ data }) => {
  //     const { token } = data;
  //     commit('addTokenToState', token);
  //     commit('mapRouter', null, { root: true });
  //     return data;
  //   });
  // },
  register({ commit }, member) {
    return AuthApi.register(member).then(({ data }) => {
      const { token } = data;
      commit('addTokenToState', token);
      Vue.nextTick(() => {
        if (!member.skipRouterMapping) commit('mapRouter', null, { root: true });
      });
      return data;
    });
  },
  // signin({ commit }, member) {
  //   return AuthApi.login(member).then(({ data }) => {
  //     const { token } = data;
  //     commit('addTokenToState', token);
  //     if (!member.skipRouterMapping) commit('mapRouter', null, { root: true });
  //     return data;
  //   });
  // },
  signin({ commit, dispatch }, member) {
    return AuthApi.login(member).then(({ data }) => {
      const { token } = data;
      commit('addTokenToState', token);
      Vue.nextTick(() => {
        if (!member.skipRouterMapping) commit('mapRouter', null, { root: true });
        commit('shop/setCartInitialised', false, { root: true });
        dispatch('shop/initCart', null, { root: true });
      });
      return data;
    });
  },
  // signout({ commit, dispatch }) {
  //   // commit('authRemove');
  //   // commit('mapRouter', null, { root: true });
  //   // // commit(
  //   // //   'shop/setCart',
  //   // //   {
  //   // //     qty: 0,
  //   // //     sum: 0,
  //   // //     articles: []
  //   // //   },
  //   // //   { root: true }
  //   // // );
  //   // dispatch('shop/initCheckoutForm', null, { root: true });
  //   // commit('shop/setCartInitialised', null, { root: true });
  //   // dispatch('shop/initCart', null, { root: true });
  //   // return AuthApi.removeToken();

  //   commit('authRemove');
  //   AuthApi.removeToken();
  //   apolloProvider.clients.public.clearStore();
  //   apolloProvider.clients.private.clearStore();

  //   setTimeout(() => {
  //     router.push('/').finally(() => {
  //       commit('authRemove');
  //       commit('shop/setCustomer', undefined, { root: true });
  //       AuthApi.removeToken();

  //       commit('mapRouter', null, { root: true });
  //       commit('shop/setCartInitialised', false, { root: true });
  //       dispatch('shop/initCart', null, { root: true });
  //       dispatch('shop/initCheckoutForm', null, { root: true });
  //     });
  //   }, 300);
  // },
  signout({ commit, dispatch }) {
    AuthApi.removeToken();
    Vue.nextTick(() => {
      // router.go({ path: "/", force: true })
      window.location.replace('/');
    });
  },

  fetchAuthenticatedMember({ commit, dispatch }) {
    return AuthApi.fetchAuthenticatedMember()
      .then(member => {
        commit('addMemberToState', member);
        commit('shop/setCartInitialised', false, { root: true });
        dispatch('shop/initCart', member, { root: true });
        return member;
      })
      .catch(error => {
        console.error(error);
        commit('authRemove');
        commit('mapRouter', null, { root: true });
        AuthApi.removeToken();
      });
  },
  sendResetLinkEmail(context, payload) {
    return AuthApi.sendResetLinkEmail(payload);
  },
  resetPassword(context, payload) {
    return AuthApi.resetPassword(payload);
  },
  verifyEmail(context, payload) {
    return AuthApi.verifyEmail(payload);
  },
  updateMember({ commit }, member) {
    return MemberApi.update(member).then(member => {
      commit('addMemberToState', member);
      return member;
    });
  }
};

// mutations
const mutations = {
  addTokenToState(state, token) {
    if (token !== undefined) {
      const decodedJWT = jwtDecode(token);

      state.token = token;
      state.jwt = decodedJWT;
      // state.signin = true

      AuthApi.setToken(token);
    } else {
      throw 'Authetication failed: Token undefined';
    }
  },
  addMemberToState(state, member) {
    if (member !== undefined) {
      member = cloneDeep(member);

      if (member.customer && member.customer.shoppingCart) {
        delete member.customer.shoppingCart;
      }

      state.member = member;
    } else {
      throw 'Authetication failed: Member undefined';
    }
  },
  updateMemberSettings(state, settings) {
    state.member.settings = settings;
  },
  authFail(state) {
    state.signin = false;
    AuthApi.removeToken();
  },
  // authReset (state) {
  // },
  // authForgot (state) {
  // },
  authRemove(state) {
    state.token = undefined;
    state.jwt = undefined;
    state.member = {};
  }
};

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
};
